import { render, staticRenderFns } from "./ModalHelp.vue?vue&type=template&id=18e751d6&"
import script from "./ModalHelp.vue?vue&type=script&lang=js&"
export * from "./ModalHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports